export default "__VITE_ASSET__C6yPdeoV__"